// removed by extract-text-webpack-plugin
module.exports = {"ratio-16-9":"ratio__ratio-16-9___2FcHx","ratio-4-3":"ratio__ratio-4-3___2HYpx","ratio-6-4":"ratio__ratio-6-4___3cTTo","ratio-8-5":"ratio__ratio-8-5___IeKEC","ratio-7-5":"ratio__ratio-7-5___1ZIyg","ratio-1-1":"ratio__ratio-1-1___wB_WL"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-aspect-ratio/AspectRatio/style/ratio.css
// module id = 86
// module chunks = 0 30